var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetryArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 3.33337V8.33337M0.833252 8.33337H5.83325M0.833252 8.33337L4.69992 4.70004C5.85068 3.55122 7.34363 2.80751 8.95382 2.58097C10.564 2.35442 12.2042 2.65732 13.6273 3.44401C15.0504 4.2307 16.1792 5.45857 16.8438 6.94262C17.5083 8.42667 17.6726 10.0865 17.3118 11.672C16.951 13.2575 16.0846 14.6828 14.8434 15.7332C13.6021 16.7835 12.053 17.402 10.4297 17.4954C8.80632 17.5889 7.19657 17.1522 5.84297 16.2512C4.48936 15.3502 3.46525 14.0337 2.92492 12.5",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryArrow);
export default __webpack_public_path__ + "a5a44c9a5df0d14889f70e985c97c254.svg";
export { ForwardRef as ReactComponent };